/**
 * Lightweight Shopify section helpers (recently viewed, newsletter popup).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'theme:recently-viewed-products';
  var MAX_RECENT = 12;

  function readRecent() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeRecent(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* storage full or blocked */
    }
  }

  window.ShopifySections = {
    trackRecentlyViewedProduct: function (productId) {
      if (!productId) return;
      var id = Number(productId);
      if (!id) return;
      var items = readRecent().filter(function (item) {
        return Number(item) !== id;
      });
      items.unshift(id);
      writeRecent(items.slice(0, MAX_RECENT));
    },

    markNewsletterPopupFilled: function () {
      try {
        sessionStorage.setItem('theme:newsletter-popup-filled', '1');
      } catch (e) {
        /* ignore */
      }
    }
  };
})();
